import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";

const useStyles = makeStyles((theme) => ({
    deleteButton: {
        color: theme.palette.error.main,
    },
}));

export default function DeleteHistoricAuditDialog({ open, onCancel, onDelete, auditId }) {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
        >
            <DialogTitle>Delete Historic Audit</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Audit {auditId} will be permanently deleted. This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onCancel}
                    color="secondary"
                    variant="text"
                >
                    Cancel
                </Button>
                <Button
                    onClick={onDelete}
                    className={classes.deleteButton}
                    variant='text'
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}